import { createContext, useCallback, useContext, useEffect, useState } from "react";

const KEY = "edi-a11y";
export const A11Y_DEFAULTS = { textSize: 100, contrast: false, font: false, spacing: false, links: false, motion: false };
const CLASS_MAP = { contrast: "a11y-contrast", font: "a11y-font", spacing: "a11y-spacing", links: "a11y-links", motion: "a11y-motion" };

function read() {
    try {
        return { ...A11Y_DEFAULTS, ...JSON.parse(localStorage.getItem(KEY) || "{}") };
    } catch {
        return { ...A11Y_DEFAULTS };
    }
}

const A11yContext = createContext(null);

export function A11yProvider({ children }) {
    const [settings, setSettings] = useState(read);

    useEffect(() => {
        const c = document.documentElement.classList;
        c.toggle("a11y-text-125", settings.textSize === 125);
        c.toggle("a11y-text-150", settings.textSize === 150);
        Object.entries(CLASS_MAP).forEach(([k, cls]) => c.toggle(cls, Boolean(settings[k])));
        localStorage.setItem(KEY, JSON.stringify(settings));
    }, [settings]);

    const update = useCallback((patch) => setSettings((s) => ({ ...s, ...patch })), []);
    const reset = useCallback(() => setSettings({ ...A11Y_DEFAULTS }), []);

    return <A11yContext.Provider value={{ settings, update, reset }}>{children}</A11yContext.Provider>;
}

export const useA11y = () => useContext(A11yContext);
